<template>
  <button v-show="visible" :class="$style.button" @click="scrollToTop">
    <i class="chevron up icon" />
  </button>
</template>

<script>
export default {
  data () {
    return {
      OFFSET: 600,
      visible: false
    }
  },
  created () {
    window.addEventListener('scroll', this.updateVisible)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.updateVisible)
  },
  methods: {
    scrollToTop () {
      if (window.pageYOffset > 0) {
        window.scrollTo(0, 0)
      }
    },
    updateVisible () {
      this.visible = window.pageYOffset > this.OFFSET
    }
  }
}
</script>

<style module>
@import "~@/stylesheets/breakpoints.css";

.button {
  position: fixed;
  bottom: 4vh;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.6;
  border-radius: 50% !important;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border: 1px solid rgba(0, 0, 0, 0.87);
  width: 35px;
  height: 35px;
  outline: 0;
  cursor: pointer;
  padding: 0;

  & :global(.icon) {
    margin: 0;
  }
}
</style>
